import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'vi-dropdown',
  templateUrl: 'dropdown.component.html',
  styleUrls: ['dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViDropdownComponent {
  @Input() placeholder = '';
  @Input() option: any = null;
  @Input() options: any[];
  @Input() width = '100%';
  @Input() disabled = false;

  @Output() optionChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(private cdr: ChangeDetectorRef) {}

  onChange(option: any): void {
    this.option = option;
    this.optionChange.emit(option);
    this.cdr.markForCheck();
  }

  clear(): void {
    this.option = null;
    this.onChange(null);
  }
}
